import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import products from "../../data/products";
import "./ProductModal.css";

function ProductPage({ onAddToCart }) {
  const [imgIdx, setImgIdx] = useState(0);
  const [size, setSize] = useState("M");
  const [added, setAdded] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  console.log(id);

  const allProducts = useMemo(() => {
    return Object.values(products).flatMap((cat) => cat.items);
  }, []);

  const product = allProducts.find((p) => String(p.id) === id);
  console.log("ID:", id);
  console.log("PRODUCT:", product);
  console.log(product);

  if (!product) {
    return (
      <>
        <Helmet>
          <title>Product Not Found</title>
        </Helmet>
        <div>Product not found</div>
      </>
    );
  }

  const handleAdd = () => {
    onAddToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div className="product-page">
      <Helmet>
        <title>
          {product ? `${product.name} | NASTY AUTHENTIC` : "Loading..."}
        </title>
        {product && (
          <meta
            name="description"
            content={`Buy ${product.name} at ₹${product.price}`}
          />
        )}
      </Helmet>
      {/* Close Button */}
      <div className="top-bar">
        <IconButton
          sx={{ color: "#fff", ml: "auto" }}
          onClick={() => navigate(-1)}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <Box className="modal-inner">
        {/* LEFT: Images */}
        <Box sx={{ width: "100%" }}>
          <img
            src={product.images[imgIdx]}
            alt={product.name}
            className="main-image"
            loading="lazy"
          />

          <Box className="thumb-row">
            {product.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`${product.name} thumbnail ${i + 1}`}
                className={`thumb ${i === imgIdx ? "active" : ""}`}
                onClick={() => setImgIdx(i)}
                loading="lazy"
              />
            ))}
          </Box>
        </Box>

        {/* RIGHT: Content */}
        <Box className="content">
          {product.tag && (
            <Typography className="tag">{product.tag}</Typography>
          )}

          <Typography component="h1" className="title">
            {product.name}
          </Typography>

          <Typography className="price">
            ₹{product.price.toLocaleString("en-IN")}
          </Typography>

          {/* Sizes */}
          <Box className="size-section">
            <Typography className="size-label">SELECT SIZE</Typography>

            <Box className="size-row">
              {["XS", "S", "M", "L", "XL", "XXL"].map((s) => (
                <Button
                  key={s}
                  onClick={() => setSize(s)}
                  className={`size-btn ${size === s ? "active" : ""}`}
                >
                  {s}
                </Button>
              ))}
            </Box>
          </Box>

          {/* Description */}
          <Box className="desc">
            <p>
              {product.name} is a premium streetwear essential made from 100%
              organic cotton. Designed for everyday comfort with a modern fit.
              Ideal for casual wear, gym, or layering.
            </p>
            <p>100% organic cotton · Pre-washed · Regular fit</p>
          </Box>

          {/* CTA */}
          <Button
            fullWidth
            onClick={handleAdd}
            className={`buy-btn ${added ? "added" : ""}`}
          >
            {added ? "✓ ADDED TO CART" : "ADD TO CART"}
          </Button>
        </Box>
      </Box>
    </div>
  );
}

export default ProductPage;
